
















import { defineComponent, computed } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import useWriteReviewDrawerOpener from '~/hooks/useWriteReviewDrawerOpener';
import { useReview } from '@vue-storefront/novulo';

export default defineComponent({
  name: 'ReviewsBar',
  components: {
    SfLink
  },
  props: {
    score: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 5
    },
    reviewsCount: {
      type: Number,
      required: true,
      validator: (value) => value >= 0
    },
    large: {
      type: Boolean,
      default: false
    },
    writeReviewLink: {
      type: String,
      default: ''
    },
    hasScore: {
      type: Boolean,
      required: false,
      default: true
    },
    productId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  setup(props) {
    const { getWriteReviewEssentials } = useReview();
    const { toggleWriteReviewDrawer } = useWriteReviewDrawerOpener();

    // displayed score value replaces dot wit comma
    const displayedScore = computed(() =>
      props.score.toFixed(2).replace('.', ',')
    );

    const handleOpenWriteReviewDrawer = () => {
      getWriteReviewEssentials(props.productId);
      toggleWriteReviewDrawer(true);
    };

    return {
      displayedScore,
      handleOpenWriteReviewDrawer
    };
  }
});
